import Dialogs from './Dialogs';
import ConnectedDialogs from './ConnectedDialogs';

export { Dialogs };
export default ConnectedDialogs;
